import { useRef } from 'react';

import BpkInput, {
  withOpenEvents,
} from '@skyscanner/backpack-web/bpk-component-input';
import BpkPopover from '@skyscanner/backpack-web/bpk-component-popover';
import { cssModules } from '@skyscanner/backpack-web/bpk-react-utils';

import GuestsRoomsChildren from '../GuestsRoomsChildren';

import type { I18nService } from '@shared/types/i18n';

import STYLES from './GuestsRoomsChildrenPopover.module.scss';

import { withI18n } from '@shared/ui/contexts/i18n';
import getGuestsRoomsChildrenValue from '@shared/utils-frontend/getGuestsRoomsChildrenValue';

const EnhancedInput = withOpenEvents(BpkInput);
const cls = cssModules(STYLES);

type Props = {
  i18n: I18nService;
  isOpen: boolean;
  adults: number;
  rooms: number;
  childrenAges: number[];
  guestsRoomsFieldId: string;
  label?: string;
  onOpen: () => void;
  onClose: Function;
  onGuestsRoomsChildrenChanged: (
    rooms: number,
    adults: number,
    childrenAges: number[],
  ) => void;
  hideLabel?: boolean;
};

const GuestsRoomsChildrenPopover = ({
  adults,
  childrenAges,
  guestsRoomsFieldId,
  hideLabel,
  i18n,
  isOpen,
  label,
  onClose,
  onGuestsRoomsChildrenChanged,
  onOpen,
  rooms,
}: Props) => {
  const target = useRef(null);

  return (
    <div className={STYLES.GuestsRoomsChildrenPopover}>
      <BpkPopover
        id="guest-rooms-children-popover"
        target={
          <div ref={target}>
            <EnhancedInput
              className={cls(
                STYLES.GuestsRoomsChildrenPopover__popoverInput,
                hideLabel &&
                  STYLES.GuestsRoomsChildrenPopover__popoverInputHideLabel,
              )}
              id={guestsRoomsFieldId}
              name={guestsRoomsFieldId}
              value={getGuestsRoomsChildrenValue({
                adults,
                rooms,
                childrenAges,
                translatePlural: i18n.translatePlural,
              })}
              readOnly
              isOpen={isOpen}
              onOpen={onOpen}
              data-test-id={guestsRoomsFieldId}
              aria-label={label}
            />
          </div>
        }
        onClose={() => onClose()}
        isOpen={isOpen}
        label="Popover"
        closeButtonText={i18n.translate('HotelStay_label_Done')}
      >
        <div className={cls('GuestsRoomsChildrenPopover__popoverContent')}>
          <GuestsRoomsChildren
            adults={adults}
            rooms={rooms}
            childrenAges={childrenAges}
            onGuestsRoomsChildrenChanged={onGuestsRoomsChildrenChanged}
          />
        </div>
      </BpkPopover>
    </div>
  );
};

export default withI18n(GuestsRoomsChildrenPopover);
